import  VueRouter from 'vue-router';

import routes from "@/router/routes";
import store from '@/store/index';
import slideToClickedSlide from "swiper/src/components/core/slide/slideToClickedSlide";

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
/*VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}*/
//重写push|replace
/*VueRouter.prototype.push = function(location, resolve, reject) {
    if(resolve && reject) {
        originalPush.call(this, location, resolve, reject);
    } else {
        originalPush.call(this, location, () => {}, () => {});
    }
}
VueRouter.prototype.replace = function(location, resolve, reject) {
    if(resolve && reject) {
        originalReplace.call(this, location, resolve, reject);
    } else {
        originalReplace.call(this, location, () => {}, () => {});
    }
}*/

let router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
       return { y: 0 }
    }
});

//路由的插件
const loadComponent = (view) => {
    if(view.substring(0,1)=="/"){
        view=view.substring(1);
    }
    if (process.env.NODE_ENV === 'development') {
        return (resolve) => require([`@/pages/${view}`], resolve)
    } else {
        return () => import(`@/pages/${view}`)
    }
}

router.initRouter = (menuList) => {
    for(let menu of menuList) {
        //没有数据的不绑定
        if(menu.componentPath==undefined || menu.componentPath ==null || menu.componentPath=="" || menu.componentPath=="null"){
            continue;
        }
        router.addRoute({
            path: menu.url,
            component: loadComponent(menu.componentPath),
            name: menu.name,
            meta: menu.meta
        });
    }
    router.addRoute({path: '*',redirect: '/index'});
}

router.beforeEach(async (to, from, next) => {
    document.title = '重庆市工业和信息化发展中心'
    // next()
    if(store.state.navbar.navbarList.length === 0 || store.state.navbar.routesList.length === 0) {
        await store.dispatch('getNavbarList')
        router.initRouter(store.state.navbar.routesList)
        next(to.fullPath)
    } else {
        next()
    }
});

export default router;
